import { render } from "./readReceiptDialog.vue?vue&type=template&id=103b5294&scoped=true&ts=true"
import script from "./readReceiptDialog.vue?vue&type=script&lang=ts"
export * from "./readReceiptDialog.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=103b5294&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103b5294"]])

export default __exports__